document.querySelectorAll('.video-story-block').forEach((container) => {
  const video = container.querySelector('video');
  const playIcon = container.querySelector('.play_icon');
  const pauseIcon = container.querySelector('.pause_icon');

  // Toggle play/pause when clicking play/pause icon
  container.querySelectorAll('.play_icon, .pause_icon').forEach((icon) => {
    icon.addEventListener('click', () => {
      if (video.paused) {
        // Pause all other videos
        document.querySelectorAll('.video-story-block video').forEach(v => {
          if (v !== video) {
            v.pause();
          }
        });
        video.play();
      } else {
        video.pause();
      }
    });
  });

  // Video is playing
  video.addEventListener('play', () => {
    container.classList.add('video-playing');
    container.classList.remove('video-paused');
    playIcon.style.display = 'none';
    pauseIcon.style.display = 'block';
    video.setAttribute('controls', true);
  });

  // Video is paused or ended
  const resetVideo = () => {
    container.classList.remove('video-playing');
    container.classList.add('video-paused');
    playIcon.style.display = 'block';
    pauseIcon.style.display = 'none';
    video.removeAttribute('controls');
  };
  video.addEventListener('pause', resetVideo);
  video.addEventListener('ended', resetVideo);
});


 document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".testimonial-swiper", {
      slidesPerView: 1,
      spaceBetween: 30,
      pagination: {
        el: ".testimonial-slider-section .swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        600: { 
          spaceBetween: 50,
          slidesPerView: 2,
        },
        1000: { 
          slidesPerView: 2,
        },
        1024: { 
          slidesPerView: 3,
          spaceBetween: 90,
         }
        
      }
    });
  });

 function getOuterHeight(el, includeMargin = false) {
  if (!el) return 0;

  let height = el.offsetHeight; // includes padding + border

  if (includeMargin) {
    const style = getComputedStyle(el);
    height += parseInt(style.marginTop) + parseInt(style.marginBottom);
  }
  if(document.querySelector('.testimonial-swiper')!=null){
    const el = document.querySelector('.testimonial-swiper');
    const style = getComputedStyle(el);

    // Get paddings
    height += parseInt(style.paddingTop);
    height += parseInt(style.paddingBottom);

    // Get borders
    height += parseInt(style.borderTopWidth);
    height += parseInt(style.borderBottomWidth);
    height += parseInt(style.borderLeftWidth);
    height += parseInt(style.borderRightWidth);

    console.log("paddingTop",height);
  }

  return height;
}
if(document.querySelector('.testimonial-slider-section')!= null){
  const testimonialSection = document.querySelector('.testimonial-slider-section');
  var testimonialHeight = getOuterHeight(testimonialSection, true);
  testimonialHeight = (testimonialHeight/2);
  document.documentElement.style.setProperty('--my-testimonial-var', -testimonialHeight+'px');
}

/****************************** PDP PAGE TWO COLUMN GALLERY VARIANT WISE IMAGE ACTIVE CLASS JS START***********************/
jQuery(document).ready(function(){
  setTimeout(function(){ variantPriceSet(); }, 500);
});

jQuery(document).on('change', ".product-info .variant-picker__option .variant-quantity", function(){
  variantPriceSet();
});

jQuery(document).on("click", ".product-info .ctr-product-option__list .ctr-product-option__item", function(){
  setTimeout(function(){ variantPriceSet(); }, 200);
});

jQuery(document).on("change", ".product-info .recharge_radio", function() {
  var selector = '.recharge_custom_block .price-list-wrapper';

  // Already exists → run directly
  if(jQuery('.product-info__block-list').find(selector).length > 0){
    setTimeout(function(){ variantPriceSet(); }, 500);
    return;
  }

  // First click → wait for DOM injection
  var observer = new MutationObserver(function(mutations, obs){
    if(jQuery('.product-info__block-list').find(selector).length > 0){
      obs.disconnect();
      variantPriceSet();
    }
  });

  observer.observe(
    document.querySelector('.product-info__block-list') || document.body,
    { childList: true, subtree: true }
  );

  // Stop observing after 5s as safety
  setTimeout(function(){ observer.disconnect(); }, 5000);
});



function variantPriceSet(){
  if(jQuery('.product-info__block-list').find('.recharge_custom_block .price-list-wrapper').length>0){
    var getActiveProductId = 0;
    if(jQuery('.product-info__block-list').find('.ctr-product-option__list').find('.ctr-product-option__button.m-active').length>0){
      getActiveProductId = jQuery('.section-spacing').find('.product-tabs').filter(function() {
        return jQuery(this).css('display') !== 'none';
      }).first().attr('data-pmain-id');
      console.log("getActiveProductId-->", getActiveProductId)
      var mainObj = jQuery('[data-pmain-id="'+getActiveProductId+'"]');
      var radioId = mainObj.find(".variant-picker__option").find(".variant-quantity:checked").attr('id');
      var variantId = mainObj.find(".variant-picker__option").find(".variant-quantity:checked").attr('data-vid');
      var sellingPlanId = mainObj.find(".variant-picker__option").find(".variant-quantity:checked").attr('data-selling-id');
      // Scope all writes to the ACTIVE flavor's form only.
      // Previously these used a page-wide selector with .eq(0), which always
      // targeted the FIRST flavor's form. Any flavor after the first never got
      // its variant id written, so it submitted the default 1-serving variant.
      var activeForm = mainObj.find('.shopify-product-form');
      if(variantId!=undefined && variantId!=""){
        if(activeForm.length>0){
          activeForm.find('[name="id"]').val(variantId);
        }
      }
      var getRechargeVal = mainObj.find('.recharge_radio:checked').val();
      if(sellingPlanId!=undefined && sellingPlanId!="" && getRechargeVal=='subscribe'){
        if(activeForm.length>0){
          activeForm.find('[name="selling_plan"]').val(sellingPlanId);
        }
      }else{
        activeForm.find('[name="selling_plan"]').val('');
      }
      if(radioId!="" && radioId!=undefined){
        if(mainObj.find('.variant-picker__option-values').find('[for="'+radioId+'"]').length>0){
          var getMainPrice = 0;
          var getComparePrice=0;
          var getServingtext = '';
          var getServingNumber = '';
          var getMainPriceval=0;
          var getServingDay='';
          var getCPriceval = '';
          if(mainObj.find('.variant-picker__option-values').find('[for="'+radioId+'"]').find('.compare--at-price').length>0){
            getComparePrice = mainObj.find('.variant-picker__option-values').find('[for="'+radioId+'"]').find('.compare--at-price').eq(0).text();
            getComparePrice = getComparePrice.trim();
            mainObj.find('.recharge_custom_block').find('[for="rechargeblock_'+getActiveProductId+'"]').find('.compare-at-price').eq(0).show();
            mainObj.find('.recharge_custom_block').find('[for="rechargeblock_'+getActiveProductId+'"]').find('.compare-at-price').text(getComparePrice);
          }else{
            mainObj.find('.recharge_custom_block').find('[for="rechargeblock_'+getActiveProductId+'"]').find('.compare-at-price').eq(0).hide();
          }
          if(mainObj.find('.variant-picker__option-values').find('[for="'+radioId+'"]').find('.price').length>0){
            getMainPrice = mainObj.find('.variant-picker__option-values').find('[for="'+radioId+'"]').find('.price').eq(0).text();
            getMainPrice = getMainPrice.trim();

            getMainPriceval = mainObj.find(".variant-picker__option").find(".variant-quantity:checked").attr('data-main-price');

            getCPriceval = mainObj.find(".variant-picker__option").find(".variant-quantity:checked").attr('data-c-price');

            getServingDay = mainObj.find(".variant-picker__option").find(".variant-quantity:checked").attr('data-serving-onetime');
            console.log("getMainPriceval",getActiveProductId,getMainPrice);
            mainObj.find('.recharge_custom_block').find('[for="rechargeblock_'+getActiveProductId+'"]').find('.sale-price').text(getMainPrice);
            mainObj.find('.recharge_custom_block').find('[for="subscribeblock_'+getActiveProductId+'"]').find('.sale-price').text(getMainPriceval);
            if(getCPriceval!="" && getCPriceval!=undefined){
              mainObj.find('.recharge_custom_block').find('[for="subscribeblock_'+getActiveProductId+'"]').find('.compare-at-price').show();
              mainObj.find('.recharge_custom_block').find('[for="subscribeblock_'+getActiveProductId+'"]').find('.compare-at-price').text(getCPriceval);
            }else{
              mainObj.find('.recharge_custom_block').find('[for="subscribeblock_'+getActiveProductId+'"]').find('.compare-at-price').hide();
            }
            if(getServingDay!="" && getServingDay!=undefined){
              mainObj.find('.recharge_custom_block').find('[for="subscribeblock_'+getActiveProductId+'"]').find('.serving-price').text(getServingDay+' / Serving');
            }
          }

          if(mainObj.find('.variant-picker__option-values').find('[for="'+radioId+'"]').find('.price-per-serving.subscribe-serving-price').length>0){
            var savePrice = mainObj.find('.variant-picker__option-values').find('[for="'+radioId+'"]').find('.price-per-serving.subscribe-serving-price').attr('data-save');
            var subBodyText = mainObj.find('.recharge_custom_block').find('.subscribe_recharge_block').find('.block-body');
            subBodyText.find('li').each(function(){
              var liText = jQuery(this).text();
              if(liText.includes("You're saving")){
                jQuery(this).find('strong').text(savePrice);
              }
            });
          }

          if(mainObj.find('.variant-picker__option-values').find('[for="'+radioId+'"]').find('.price-per-serving').length>0){
            getServingtext = mainObj.find('.variant-picker__option-values').find('[for="'+radioId+'"]').find('.price-per-serving').eq(0).text();
            mainObj.find('.recharge_custom_block').find('[for="rechargeblock_'+getActiveProductId+'"]').find('.serving-price').text(getServingtext);
          }
          if(mainObj.find('.variant-picker__option-values').find('[for="'+radioId+'"]').find('.serving--number').length>0){
            getServingNumber = mainObj.find('.variant-picker__option-values').find('[for="'+radioId+'"]').find('.serving--number').eq(0).text();
            var finalServingNumber = getServingNumber.match(/\d+/)[0];
            var subsServeringText = mainObj.find('.recharge_custom_block').find('.subscribe_recharge_block').find('.short-title').text();
            var updatedText = subsServeringText.replace(/^\d+/, finalServingNumber);
            
            mainObj.find('.recharge_custom_block').find('.subscribe_recharge_block').find('.short-title').text(updatedText);
            mainObj.find('.recharge_custom_block').find('.ontime_recharge_block').find('.short-title').text(getServingNumber);
          }
          
          //when subscribe block change show hide for onetime and subscribe price for variant wise js start
          if(mainObj.find('.recharge_radio').length>0){
            if(getRechargeVal == 'subscribe'){
              mainObj.find('.variant-picker__option-values').find('.onetime-variant-price').hide();
              mainObj.find('.variant-picker__option-values').find('.onetime-serving-price').hide();
              mainObj.find('.variant-picker__option-values').find('.subscribe-variant-price').show();
              mainObj.find('.variant-picker__option-values').find('.subscribe-serving-price').show();
            }else{
              mainObj.find('.variant-picker__option-values').find('.subscribe-variant-price').hide();
              mainObj.find('.variant-picker__option-values').find('.subscribe-serving-price').hide();
              mainObj.find('.variant-picker__option-values').find('.onetime-variant-price').show();
              mainObj.find('.variant-picker__option-values').find('.onetime-serving-price').show();
            }
          }
          //when subscribe block change show hide for onetime and subscribe price for variant wise js end

          //Main price set js start
          getMainPriceval = mainObj.find(".variant-picker__option").find(".variant-quantity:checked").attr('data-main-price');
          getCPriceval = mainObj.find(".variant-picker__option").find(".variant-quantity:checked").attr('data-c-price');
          //console.log("getMainPriceval",getMainPriceval,getCPriceval);
          if(mainObj.find('.product-info__block-item.block-price').find('.price-list--product').find('.text-on-sale').length>0 && getCPriceval!=undefined && getCPriceval!=""){
            setTimeout(() => {
              mainObj.find('.product-info__block-item.block-price').find('.price-list--product').find('.text-on-sale').text(getCPriceval);
            }, 50);
          }
          if(mainObj.find('.product-info__block-item.block-price').find('.price-list--product').find('.text-subdued').length>0 && getMainPriceval!=undefined && getMainPriceval!=""){
            setTimeout(() => {
              mainObj.find('.product-info__block-item.block-price').find('.price-list--product').find('.text-subdued').text(getMainPriceval);
            }, 50);
          }
          //Main price set js end
        }
      }
    }
  }
}
/****************************** PDP PAGE TWO COLUMN GALLERY VARIANT WISE IMAGE ACTIVE CLASS JS END ************************/

/************************************************* CART DRAWER JS START **************************************************/
jQuery(function ($) {
  var timerInterval;
  var endTimeKey = "countdown_end";

  function startCartTimer() {
    var $timer = $('.cart-drawer.drawer').find('.message_timer');
    if ($timer.length === 0) return; // exit if timer element not found

    var totalMinutes = parseInt($timer.data('timer'), 10);
    if (!totalMinutes || totalMinutes <= 0) return;

    var totalSeconds = totalMinutes * 60;

    var storedEndTime = parseInt(localStorage.getItem(endTimeKey), 10);
    var endTime = storedEndTime && storedEndTime > Date.now()
      ? storedEndTime
      : Date.now() + totalSeconds * 1000;

    localStorage.setItem(endTimeKey, endTime);

    function updateTimer() {
      var now = Date.now();
      var remaining = Math.max(0, Math.floor((endTime - now) / 1000));

      var displayHours   = Math.floor(remaining / 3600);
      var displayMinutes = Math.floor((remaining % 3600) / 60);
      var displaySeconds = remaining % 60;

      $timer.find('.cart-timer_hours').text(String(displayHours).padStart(2, '0'));
      $timer.find('.cart-timer_minutes').text(String(displayMinutes).padStart(2, '0'));
      $timer.find('.cart-timer_seconds').text(String(displaySeconds).padStart(2, '0'));

      if (remaining <= 0) {
        clearInterval(timerInterval);
        localStorage.removeItem(endTimeKey);
        $timer.hide(); // optional hide when done
      }
    }
    updateTimer(); // initial render
    clearInterval(timerInterval); // clear previous
    timerInterval = setInterval(updateTimer, 1000);
  }

  // Run on page load
  startCartTimer();

  // Re-run if cart drawer opens
  $(document).on('cartDrawerOpened', function() {
    startCartTimer();
  });

  // Button click to trigger timer
  $(".product-info__block-item .b-skio__box--btn").on("click", function() {
    var timerId = setInterval(function(){
      if($('.cart-drawer.drawer').find('.message_timer').length>0){
        startCartTimer();
        clearInterval(timerId);
      }
    },100);
  });
});

setInterval(function(){
  var cartTotalStr = $('cart-drawer').find('p.h4').eq(0).text();
  var cartTotalNum = cartTotalStr.match(/\d+/)[0];
  $('.header__cart-dot').text(cartTotalNum);
}, 1000); // repeats every 1000ms = 1 second
/************************************************* CART DRAWER JS END ***************************************************/